import { updateObject } from '../../utils/utility';

const initialState = {
    companyList: [],
    hasServerResponded: false,
    totalFinancial: 0,
    pageNumber: 0,
    totalPages: 0,
    partnerFinancialIds: [],
    financialList: [],
    filters: {},
    isSubmitClicked: false,
    message: "",
    partnerFinancialsReportList: [],
    company: null
};

const setCompany = (state = initialState, action) => {
    const data = action.payload;
    return updateObject(state, {
        company: data
    });
}

const setIsSubmitClicked = (state = initialState, action) => {
    const data=action.payload;
    return updateObject(state, {
        isSubmitClicked: data
    });
};

const setFilters = (state = initialState, action) => {
    const data=action.payload;
    return updateObject(state, {
        filters: data
    });
};

const setCompanyList = (state = initialState, action) => {
    const data=action.payload.data;
    return updateObject(state, {
        companyList: data.companyList
    });
};

const setHasResponded = (state = initialState, action) => {
    return updateObject(state, {
        hasServerResponded: action.data,
    });
};

const setExportPartnerFinancialsList = (state = initialState, action) => {
    const { financialList,totalFinancial,pageNumber,totalPage,partnerFinancialIds } = action.payload;
    return updateObject(state, {
        financialList,
        totalFinancial,
        pageNumber,
        partnerFinancialIds,
        totalPages: totalPage
    });
};

const setExportPartnerFinancials = (state = initialState, action) => {
    const data=action.payload.data;
    console.log("Message::"+JSON.stringify(data));
    return updateObject(state, {
        message: data
    });
};

const setExportPartnerFinancialsDownloadList = (state = initialState, action) => {
    const data=action.payload.data;
    return updateObject(state, {
        partnerFinancialsReportList: data.partnerFinancialsReportList
    });
};

const reducer = (state = initialState, action) => {
    if (action.type === "SET_HAS_EXPORT_PARTNER_FINANCIALS_RESPONDED") {
        return setHasResponded(state, action);
    }
    else if (action.type === "SET_EXPORT_PARTNER_FINANCIALS_COMPANY_LIST") {
        return setCompanyList(state, action);
    }
    else if (action.type === "SET_EXPORT_PARTNER_FINANCIALS_LIST") {
        return setExportPartnerFinancialsList(state, action);
    }
    else if (action.type === "SET_EXPORT_PARTNER_FINANCIALS_FILTERS") {
        return setFilters(state, action);
    }
    else if (action.type === "SET_IS_SUBMIT_CLICKED") {
        return setIsSubmitClicked(state, action);
    }
    else if (action.type === "SET_EXPORT_PARTNER_FINANCIALS") {
        return setExportPartnerFinancials(state, action);
    }
    else if (action.type === "SET_EXPORT_PARTNER_FINANCIALS_DOWNLOAD_LIST") {
        return setExportPartnerFinancialsDownloadList(state, action);
    }
    else if (action.type === "SET_COMPANY") {
        return setCompany(state, action);
    }
    return state;
};

export default reducer;